import { Button, Typography } from '@packages/ui/shared';
import { Modal } from 'react-bootstrap';

/**
 * Props for the SubmitCaseModal component.
 */
export type SubmitCaseModalProps = {
    /** Whether a submit operation is currently in progress. */
    isSubmitting: boolean;

    /** Whether the modal is visible. */
    isVisible: boolean;

    /** Callback to dismiss the modal. */
    onClose: () => void;

    /** Callback to confirm and submit the case. */
    onConfirm: () => void;
};

/**
 * Confirmation modal shown before submitting a draft Techline case for review.
 * Warns the user that the case will become visible and only partially editable
 * after submission.
 *
 * @param props - component props
 * @returns the submit case confirmation modal
 */
export function SubmitCaseModal({ isSubmitting, isVisible, onClose, onConfirm }: SubmitCaseModalProps) {
    // Forwarded callback aliases
    const handleClose = onClose;
    const handleConfirmButtonPress = onConfirm;

    return (
        <Modal centered={true} onHide={handleClose} show={isVisible} size="lg">
            <Modal.Header>
                <Modal.Title>Submit Techline Case</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Typography>
                    By submitting this case, it will become visible to Techline users. The case cannot be deleted after
                    submission, and only certain sections will remain editable. Are you sure you&apos;re ready to
                    submit?
                </Typography>
            </Modal.Body>
            <Modal.Footer>
                <div className="d-flex justify-content-end w-100">
                    <div className="mr-2">
                        <Button onPress={handleClose} variant="ghost-blue">
                            Cancel
                        </Button>
                    </div>
                    <Button isLoading={isSubmitting} onPress={handleConfirmButtonPress} variant="primary">
                        Submit
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
}
